import api from "../config/api";

export const fetchAllProduct = async () => {
    const res = await api.get(`/product/`);
    return res.data.data;
}
export const fetchProductById = async (id) => {
    const res = await api.get(`/product/?id=${id}`); 
    return res.data.data;
}

export const createProduct = async (productData) => {
  const config = productData instanceof FormData 
    ? { headers: { "Content-Type": "multipart/form-data" }} 
    : { headers: { "Content-Type": "application/json" } };

  const res = await api.post(`/product/`, productData, config);
  return res.data; 
};

export const updateProduct = async (id, productData) => {
  const config = productData instanceof FormData 
    ? {} 
    : { headers: { "Content-Type": "application/json" } };

  const res = await api.post(`/product/?id=${id}`, productData, config);
  return res.data;
};
export const deleteProduct = async (id) => {
    const res = await api.delete(`/product/?id=${id}`);
    return res.data.data;
}
export const fetchAllCustomerProduct = async () => {
    const res = await api.get(`/product/customer/`);
    return res.data.data;
}
export const fetchCustomerProductById = async (id) => {
    const res = await api.get(`/product/customer/?id=${id}`); 
    return res.data.data;
}
export const verifyProductCode = async (code) => {
  const res = await api.get(`/product/?code=${code}&action=verify`);
  return res.data.data;
}